import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im";
import PriceInput from "./priceInput";

function InfoManager({ data, setData }) {
  function formatPhone(value) {
    const numbers = value.replace(/\D/g, "");

    if (numbers.length <= 2) {
      return `(${numbers}`;
    }

    if (numbers.length <= 7) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    }

    if (numbers.length <= 11) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
    }

    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
  }

  return (
    <div className="card info">
      <div className="card-content">
        <label className="subtitle">Número de Contato</label>
        <input
          value={formatPhone(data.additions?.contact_phone || "")}
          onChange={(e) => {
            const onlyNumbers = e.target.value.replace(/\D/g, "");

            setData((prev) => ({
              ...prev,
              additions: {
                ...prev.additions,
                contact_phone: onlyNumbers,
              },
            }));
          }}
        />
        <label
          className="subtitle action"
          style={{ width: "100%", justifyContent: "flex-start" }}
          onClick={() =>
            setData((prev) => ({
              ...prev,
              additions: {
                ...prev.additions,
                delivery: !prev.additions.delivery,
              },
            }))
          }
        >
          Permitir entrega?
          <span>
            {data.additions?.delivery ? (
              <ImCheckboxChecked />
            ) : (
              <ImCheckboxUnchecked />
            )}{" "}
          </span>
        </label>

        {data.additions?.delivery && (
          <>
            <label className="subtitle">Minimo para entrega grátis</label>
            <PriceInput
              value={data.additions?.free_delivery_minimun || 0}
              onChange={(value) => {
                setData((prev) => ({
                  ...prev,
                  additions: {
                    ...prev.additions,
                    free_delivery_minimun: value,
                  },
                }));
              }}
            />

            <label className="subtitle">Preço de entrega</label>
            <PriceInput
              value={data.additions?.delivery_price || 0}
              onChange={(value) => {
                setData((prev) => ({
                  ...prev,
                  additions: {
                    ...prev.additions,
                    delivery_price: value,
                  },
                }));
              }}
            />
          </>
        )}
        <label className="subtitle">Inativo</label>
        <textarea
          rows="4"
          cols="30"
          placeholder="Escreva aqui a mensagem que irá aparecer quando o os pedidos não estiverem sendo recebidos"
          value={data.additions?.innactiveWarning || ""}
          onChange={(e) =>
            setData({
              ...data,
              additions: {
                ...data.additions,
                innactiveWarning: e.target.value,
              },
            })
          }
        />
        <label className="subtitle">Em pausa</label>
        <textarea
          rows="4"
          cols="30"
          placeholder="Escreva aqui a mensagem que irá aparecer quando o os pedidos estiverem pausados"
          value={data.additions?.pauseWarning || ""}
          onChange={(e) =>
            setData({
              ...data,
              additions: {
                ...data.additions,
                pauseWarning: e.target.value,
              },
            })
          }
        />
        <ul>
          {[
            { key: "monday", label: "segunda" },
            { key: "tuesday", label: "terça" },
            { key: "wednesday", label: "quarta" },
            { key: "thursday", label: "quinta" },
            { key: "friday", label: "sexta" },
            { key: "saturday", label: "sábado" },
            { key: "sunday", label: "domingo" },
          ].map(({ key, label }) => (
            <li key={key}>
              <label className="subtitle">{label}</label>
              <input
                value={data.additions?.workingHours?.[key] || ""}
                onChange={(e) =>
                  setData((prev) => ({
                    ...prev,
                    additions: {
                      ...prev.additions,
                      workingHours: {
                        ...prev.additions.workingHours,
                        [key]: e.target.value,
                      },
                    },
                  }))
                }
              />
            </li>
          ))}
        </ul>
        <label
          className="subtitle action"
          onClick={() =>
            setData((prev) => ({
              ...prev,
              additions: {
                ...prev.additions,
                vacation: !prev.additions.vacation,
              },
            }))
          }
        >
          Férias{" "}
          <span>
            {data.additions?.vacation ? (
              <ImCheckboxChecked />
            ) : (
              <ImCheckboxUnchecked />
            )}{" "}
          </span>
        </label>
        <label className="subtitle">De férias</label>
        <textarea
          rows="4"
          cols="30"
          placeholder="Escreva aqui a mensagem que irá aparecer quando estiver de férias"
          value={data.additions?.vacationWarning || ""}
          onChange={(e) =>
            setData({
              ...data,
              additions: {
                ...data.additions,
                vacationWarning: e.target.value,
              },
            })
          }
        />
      </div>
    </div>
  );
}

export default InfoManager;
